export const types = {
  SET_APP_BAR_TITLE: 'APP/SET_APP_BAR_TITLE',
  SET_APP_OUTAGE: 'APP/SET_APP_OUTAGE',
  USER_INTERACTION: 'APP/USER_INTERACTION',
  SHOW_BLOCK_NAVIGATION_MODAL: 'APP/SHOW_BLOCK_NAVIGATION_MODAL',
  HIDE_BLOCK_NAVIGATION_MODEL: 'APP/HIDE_BLOCK_NAVIGATION_MODEL',
  SET_CONTACT_TO_DELETE: 'APP/SET_CONTACT_TO_DELETE',
  SET_CONFIRMED_OPEN: 'APP/SET_CONFIRMED_OPEN',
  SET_UNSAVED: 'APP/SET_UNSAVED',
  SET_ACCOUNT_TYPE: 'APP/SET_ACCOUNT_TYPE',
  TOGGLE_CONTACT_MODAL: 'APP/SHOW_CONTACT_MODAL',
  TOGGLE_SCROLL_TO_CONTACTS: 'APP/TOGGLE_SCROLL_TO_CONTACTS',
  SET_SELECTED_APPOINTMENT: 'APP/SET_SELECTED_APPOINTMENT',
  TOGGLE_DASH_MESSAGE_EXPANDED: 'APP/TOGGLE_DASH_MESSAGE_EXPANDED',
  SET_PREFERENCES_INITIALIZED: 'APP/SET_PREFERENCES_INITIALIZED',
  SET_TERMS_ACCEPTED: 'APP/SET_TERMS_ACCEPTED',
  SET_DEFAULT_PROFILE_FIELD: 'APP/SET_DEFAULT_PROFILE_FIELD',
  SET_CONTINUE_DASH: 'APP/SET_CONTINUE_DASH',
  SET_ROUTE_CHANGE_TIME: 'APP/SET_ROUTE_CHANGE_TIME',
  ADD_BANK_UPDATE: 'APP/ADD_BANK_UPDATE',
  SET_CUSTOMER_ISOLATING: 'APP/SET_CUSTOMER_ISOLATING',
};

const initialState = {
  appBarTitle: null,
  inOutage: false,
  outageFrom: null,
  outageTo: null,
  outageMessage: null,
  message: '',
  canLeave: true,
  contactToDelete: false,
  confirmedOpen: false,
  unsaved: false,
  accountType: 'rent',
  showContactModal: false,
  scrollToContacts: false,
  selectedAppointment: null,
  dashMessageExpanded: [true, true, true],
  defaultProfileField: null,
  continueDash: false,
  routeChangeTime: Date.now(),
  numberBankUpdates: 0,
  preferencesInitialized: false,
  termsAccepted: false,
  customerIsolating: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.SET_APP_BAR_TITLE:
      return { ...state, appBarTitle: payload };
    case types.SET_APP_OUTAGE:
      if (!cmsAccess) {
        return {
          ...state,
          inOutage: true,
          outageFrom: payload.From,
          outageTo: payload.To,
          outageMessage: payload.OutageMessage,
        };
      }
    case types.SET_CONTACT_TO_DELETE:
      return { ...state, contactToDelete: payload };
    case types.SHOW_BLOCK_NAVIGATION_MODAL:
      const { message, canLeave } = action.payload;
      return { ...state, message, canLeave };
    case types.HIDE_BLOCK_NAVIGATION_MODEL:
      return {
        ...state,
        canLeave: false,
        unsaved: true,
        message: '',
      };
    case types.SET_CONFIRMED_OPEN: {
      return {
        ...state,
        confirmedOpen: !state.confirmedOpen,
      };
    }
    case types.SET_UNSAVED: {
      return {
        ...state,
        unsaved: payload,
      };
    }
    case types.SET_ACCOUNT_TYPE: {
      return {
        ...state,
        accountType: payload,
      };
    }
    case types.TOGGLE_CONTACT_MODAL: {
      return {
        ...state,
        showContactModal: !state.showContactModal,
      };
    }
    case types.TOGGLE_SCROLL_TO_CONTACTS: {
      return {
        ...state,
        scrollToContacts: payload,
      };
    }
    case types.SET_SELECTED_APPOINTMENT: {
      return {
        ...state,
        selectedAppointment: payload,
      };
    }
    case types.TOGGLE_DASH_MESSAGE_EXPANDED: {
      const dashMessageExpanded = [];
      for (let i = 0; i < 3; i++) {
        if (i == payload) {
          dashMessageExpanded.push(!state.dashMessageExpanded[i]);
        } else {
          dashMessageExpanded.push(state.dashMessageExpanded[i]);
        }
      }
      return {
        ...state,
        dashMessageExpanded: dashMessageExpanded,
      };
    }
    case types.SET_PREFERENCES_INITIALIZED: {
      return {
        ...state,
        preferencesInitialized: true,
      };
    }
    case types.SET_TERMS_ACCEPTED: {
      return {
        ...state,
        termsAccepted: true,
      };
    }
    case types.SET_DEFAULT_PROFILE_FIELD: {
      return {
        ...state,
        defaultProfileField: payload,
      };
    }
    case types.SET_CONTINUE_DASH: {
      return {
        ...state,
        continueDash: payload,
      };
    }
    case types.SET_ROUTE_CHANGE_TIME: {
      return {
        ...state,
        routeChangeTime: payload,
      };
    }
    case types.ADD_BANK_UPDATE: {
      return {
        ...state,
        numberBankUpdates: state.numberBankUpdates + 1,
      };
    }
    case types.SET_CUSTOMER_ISOLATING: {
      return {
        ...state,
        customerIsolating: payload,
      };
    }
  }

  return state;
}

export const actions = {
  setAppBarTitle: (title) => ({
    type: types.SET_APP_BAR_TITLE,
    payload: title,
  }),
  setAppOutage: (outage) => ({
    type: types.SET_APP_OUTAGE,
    payload: outage,
  }),
  userInteraction: () => ({
    type: types.USER_INTERACTION,
  }),
  setContactToDelete: (contact) => ({
    type: types.SET_CONTACT_TO_DELETE,
    payload: contact,
  }),
  setConfirmedOpen: () => ({
    type: types.SET_CONFIRMED_OPEN,
  }),
  setUnsaved: (unsaved) => ({
    type: types.SET_UNSAVED,
    payload: unsaved,
  }),
  setAccountType: (type) => ({
    type: types.SET_ACCOUNT_TYPE,
    payload: type,
  }),
  toggleContactModal: () => ({
    type: types.TOGGLE_CONTACT_MODAL,
  }),
  toggleScrollToContacts: (scrollToContacts) => ({
    type: types.TOGGLE_SCROLL_TO_CONTACTS,
    payload: scrollToContacts,
  }),
  setSelectedAppointment: (appointment) => ({
    type: types.SET_SELECTED_APPOINTMENT,
    payload: appointment,
  }),
  toggleDashMessageExpanded: (index) => ({
    type: types.TOGGLE_DASH_MESSAGE_EXPANDED,
    payload: index,
  }),
  setPreferencesInitialized: () => ({
    type: types.SET_PREFERENCES_INITIALIZED,
  }),
  setTermsAccepted: () => ({
    type: types.SET_TERMS_ACCEPTED,
  }),
  setDefaultProfileField: (field) => ({
    type: types.SET_DEFAULT_PROFILE_FIELD,
    payload: field,
  }),
  setContinueDash: (continueDash) => ({
    type: types.SET_CONTINUE_DASH,
    payload: continueDash,
  }),
  setRouteChangeTime: (time) => ({
    type: types.SET_ROUTE_CHANGE_TIME,
    payload: time,
  }),
  addBankUpdate: () => ({
    type: types.ADD_BANK_UPDATE,
  }),
  setCustomerIsolating: (isIsolating) => ({
    type: types.SET_CUSTOMER_ISOLATING,
    payload: isIsolating,
  }),
};
